import React from "react";
import { Content } from "./styles";
import Nodata from '../../assets/Nodata.svg'
export function Empty() {
  return (
    <Content>
      <img src={Nodata} alt="sem dados" />
      Sem dados.
    </Content>
  );
}
